import { render, staticRenderFns } from "./PoliticaComercialList.vue?vue&type=template&id=6c4b660e&scoped=true"
import script from "./PoliticaComercialList.vue?vue&type=script&lang=js"
export * from "./PoliticaComercialList.vue?vue&type=script&lang=js"
import style0 from "./PoliticaComercialList.vue?vue&type=style&index=0&id=6c4b660e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4b660e",
  null
  
)

export default component.exports